import { GraphQLCampaign } from 'modules/campaigns/lib';
import { Button } from 'modules/graphql';
import { AppPlatform } from 'modules/mobileApps/types';
import { SelectiveTargetingOptionValues } from 'modules/workflowNodeEditors/components/sendNodeEditors/BaseSendEditor/DeliverySection/SelectiveTargeting/SelectiveTargeting.constants';

export enum MediaLayout {
  TOP = 'top',
  RIGHT = 'right',
  NONE = 'none',
}

/**
 * Would have just renamed the actual enum values of MediaLayout but the values are already stored
 * in the BE so changing that would break implementation. It's easier to just
 * map the labels then updating the data model.
 */
export const MediaLayoutMappings = {
  top: 'card',
  right: 'banner',
  none: 'notification',
};

export type AppDestination = {
  appPackageName: string;
  platform: AppPlatform;
  appName: string;
  isActive?: boolean;
};

export type Placement = {
  placementName: string;
  description?: string;
  id: number;
  createdAt?: Date;
  createdBy?: string;
  isArchived: boolean;
  mediaLayout: MediaLayout;
  campaignLimit: number;
  hasTitle: boolean;
  hasBody: boolean;
  hasMedia: boolean;
  hasDataFeeds: boolean;
  textFields?: string[];
  hasOpenAction: boolean;
  actionButtons?: Button[];
  payload?: any;
  destinations: AppDestination[];
};

type CreatedAt = {
  timestamp: string;
  timezone: string;
};

export type PlacementGraphQLDef = {
  payload: {
    fields: Omit<Placement, 'id' | 'isArchived'>;
    id: number;
    isArchived: boolean;
    createdAt: CreatedAt;
    creatorUserId: string;
  };
  message: string;
};

export type ActionButtonToggle = { title: string; isActive: boolean };

export enum PlacementType {
  Banner = 'Banner',
  Carousel = 'Carousel or feed',
}

export type PlacementsCreateFormState = {
  placementName: string;
  description: string;
  mediaLayout: MediaLayout;
  placementType: PlacementType;
  campaignLimit: number;
  hasTitle: boolean;
  hasBody: boolean;
  hasMedia: boolean;
  hasDataFeeds: boolean;
  hasOpenAction: boolean;
  actionButtons: ActionButtonToggle[];
  payload: string;
  destinations: SelectiveTargetingOptionValues;
  textFields: string[];
};

export enum EmbeddedDestination {
  Browser = 'Browser',
  Mobile = 'Mobile',
}

type ActionInput = {
  type: string;
  data: string;
};

type ButtonInput = {
  id: string;
  title: string;
  action: ActionInput;
};

export type PlacementCreateInput = {
  placementName: string;
  description?: string;
  mediaLayout: string;
  campaignLimit: number;
  hasTitle: boolean;
  hasBody: boolean;
  hasMedia: boolean;
  hasDataFeeds: boolean;
  hasOpenAction: boolean;
  actionButtons: ButtonInput[];
  payload: string;
  destinations: EmbeddedDestination[];
  textFields: string[];
};

export enum PlacementStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export type DisplayPriorityCampaign = Pick<
  GraphQLCampaign,
  | 'campaignState'
  | 'embeddedPriorityOrder'
  | 'expectedSendSize'
  | 'id'
  | 'name'
  | 'schedulerMsgParams'
  | 'startAt'
  | 'templateId'
  | 'journey'
  | 'isJourneyAssociated'
  | 'lists'
  | 'messageMedium'
  | 'displayUntil'
> & { hidden: boolean };
